import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useGetMyNotificationsMutation } from "../../Redux/Notifications/NotificationSlice";
import GenericDropdown from '../../GenericComponents/HomeDropDown'
import AddWorkspaceDialog from "../../Pages/HomePage/WorkspaceDialogs/AddNewWorkspaceDialog";
import { FindWorkspaceDialog } from './HeaderItems/FindWorkspaceDialog'
import PatientCaseLookupDialog from './HeaderItems/FindCaseDialog'
import { useSelector, useDispatch } from 'react-redux';
import { getCurrentUserData, setAppRedirectURL, setAppWorkflowState} from "../../Redux/store";
import { useSearchablesMutation } from "../../Redux/OCV/OCVSlice";
import { RootState, getAppSettings } from '../../Redux/store'
import { getBaseUrl } from '../../Utils';
import SystemBanner from "../../Components/SystemBanner/SystemBanner";
import FindDropdown from "./HeaderItems/FindMenu";
import { FindMenuItemsResponse, SearchablesData } from "../../Types/OcvInterface";
import * as timeago from 'timeago.js';
import { createAction } from '@reduxjs/toolkit'
import { appWorkflowStates } from "../../Types/appWorkflowStates";
import Cookies from "js-cookie";
import { FoundationsConstants } from "../../FoundationsConstants";
import { useNavigate ,useLocation} from "react-router-dom";
import { adjustColor, cleanHLUserCookies, getCurrentCookiePath, redirectHome, startProxyCheckThread } from "../../GlobalMethods";
import { usePerformSignOutMutation } from "../../Redux/Admin_Tasks/AdminProcedureSlice";
import { setCurrentUserData, useUpdateUserDataMutation } from "../../Redux/User/userSlice";
import { useExitProxyMutation } from "../../Redux/UserSettings/userSettingsSlice";
import FoundationsGuide from "../../Pages/FoundationsGuide.tsx/foundationsGuide";
// import { useGetPublicDataMutation } from "../../Redux/App/appSlice";

// TO DO : add animation to inbox 
// TO DO : NEED TO FIX THE LINKS OF ROUTING ON PAGE ONCE WE HAVE ROUTING IN PLACE.

export const NotificationContext = createContext<any>(null);

export enum MenuType {
    USER = "user",
    WORKSPACE = "workspace",
    FIND = "find",
}

export function Header() {
    // TODO -> pass header props
    const [notifications, setNotifications] = useState<any[]>([]);
    const [fetchNotifications, { data: configData, error: configError, isLoading: configLoading }] = useGetMyNotificationsMutation();
    const [hasFetchedPublicApiData, setHasFetchedPublicApiData] = useState<boolean>(false);
    // const [callPublicData] = useGetPublicDataMutation();
    const [publicApiData, setPublicApiData] = useState<any>()
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const helpContainerRef = useRef<HTMLDivElement | null>(null);
    const [showHelp, setShowHelp] = useState<boolean>(false);
    const [message, setMessage] = useState("");
    const [showTutorial, setShowTutorial] = useState<boolean>(false);

    // setPublicApiData();
    const navigate = useNavigate();

    useEffect(() => {
        if (currentUserData){
            const fetchNotificationsAsync = async () => {
                const cacheBuster = Date.now(); // Generate cache-busting value
                const response: any = await fetchNotifications({
                    _: cacheBuster, // Pass as part of the query string
                }).unwrap();
    
                if (response && response.statusCode === 200) {
                    const notifications = response.data || [];
                    setNotifications(notifications);
                } else {
                    setNotifications([]);
                }
            };
            fetchNotificationsAsync(); // Call the function here without recursion
        }
    }, []);


    // useEffect(() => {
    // if (!hasFetchedPublicApiData) {

    // callPublicData({})
    //     .unwrap()
    //     .then((response: any) => {
    // setPublicApiData("response");
    //         setHasFetchedPublicApiData(true);
    //     })
    //     .catch((error: any) => {
    //         console.error('Error fetching Current User data:', error);
    //     });
    // }
    // }, [hasFetchedPublicApiData]);

    // // Fetch current user data from the Redux store
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state));
    const appSettings: any = useSelector(
        (state: RootState) => { return getAppSettings(state) || {} }
    )

    const location = useLocation();
    const prevHashRef = useRef(location.hash);
    const closeNotifications = () => {
        const notificationContainer = notificationContainerRef.current as HTMLElement | null;
        if (notificationContainer) {
            notificationContainer.style.display = "none";
        }
    };

    useEffect(() => {
        if (prevHashRef.current !== location.hash) {
            closeNotifications();
        }
        prevHashRef.current = location.hash;
    }, [location.hash]);

    let urlHash = window.location.hash;
    useEffect(() => {
        setShowHelp(false);
    }, [urlHash]);

    useEffect(() => {
        if (!showHelp) return;
        const updateMessageBasedOnHash = () => {
            if (urlHash.startsWith("#workspace")) {
                setMessage("A workspace is a shareable collection of reports and notes.");
            }
            else {
                setMessage(`Foundations™ helps you
                    make sense of
                    data and use it to improve patient care every day. See tutorial for more
                    info.&nbsp;&nbsp;➨<br><br>▼
                    Here's a list of workspaces available to you. A workspace is a shareable collection of
                    reports, forms
                    and useful analytics. Click on a workspace to open it.`);
            }
        };
       
        updateMessageBasedOnHash();
    }, [showHelp, urlHash]); 

    // useEffect for hash changes and close help box
    useEffect(() => {
        const hashChangeListener = () => {
            setShowHelp(false);
            setShowTutorial(false);
        };
        window.addEventListener("hashchange", hashChangeListener);
        return () => {
            window.removeEventListener("hashchange", hashChangeListener);
        };
    }, []);
  
    const handleShowTutorialClick = () => {
        setShowTutorial(true);
    };

    const handleTutorialClose = () => {
        setShowTutorial(false);
    };

    const showBanner =
    !!appSettings.PostLoginBannerText &&
    !!currentUserData;  // Ensure appSettings and currentUserData are defined
    const bannerConfig = {
    text: appSettings.PostLoginBannerText || "",
    isBannerGlow: false,
    show: showBanner,
    additionalClasses: "system_banner_header",
    };

    // // Assuming appSettings is available in your component
    // if (appSettings?.PostLoginBannerText) {
    //     setBannerConfig(prevConfig => ({
    //         ...prevConfig,
    //         text: appSettings..PostLoginBannerText || "", // Update banner text
    //     }));
    // }
    // useEffect(() => {
    //     if (appSettings?.PostLoginBannerText) {
    //         setBannerConfig(prevConfig => ({
    //             ...prevConfig,
    //             text: appSettings..PostLoginBannerText || "", // Update banner text
    //         }));
    //     }
    // }, [appSettings?.PostLoginBannerText]);
    const [FindeMenuItems, setFindMenuItems] = useState<any>([]);
    const [WorkspaceMenuState, SetWorkspaceMenuState] = useState({
        addWorkspace: false,
        findWorkspaces: false,
        findCase: false,
        snapshotFeed: false,
        isWorkspaceDropDownOpen: false,
        isUserDropDownOpen: false,
        isFindDropDownOpen: false,
    })

    const notificationContainerRef = useRef(null);

    return (
        <NotificationContext.Provider value={{ notifications, setNotifications, currentUserData, FindeMenuItems, setFindMenuItems, WorkspaceMenuState, SetWorkspaceMenuState, notificationContainerRef, setShowLoading ,helpContainerRef,showHelp, setShowHelp, showTutorial, setShowTutorial}}>
            <span className="header-container row">
                {currentUserData?.proxyInfo?.isProxyMode && (
                    <div id="app_proxy_banner" className={currentUserData?.proxyInfo?.proxyRole === 1 ? "proxy-banner noprint" : "proxy-as-banner noprint"}>
                        {currentUserData?.proxyInfo?.proxyMessage}
                    </div>
                )}
                <div id="system_banner_header">
                    {showLoading &&
                        <div id="app_page_loading" className="header-loading">
                            <div className="ajax-loading-box">
                                <span className="ajax-loading-image"></span>
                                Loading...
                            </div>
                        </div>
                    }
                    <SystemBanner
                        text={bannerConfig.text}
                        isBannerGlow={bannerConfig.isBannerGlow}
                        show={bannerConfig.show}
                        additionalClasses={bannerConfig.additionalClasses}
                    />
                </div>
                {/* TODO handle proxy mode here */}
                {/* TODO add print mode styling back here */}
                <div id="header_logo" className="header-logo header-menu-app col-md-12 col-lg-6 text-center text-lg-left">
                    <a href={`${location.pathname}#home`} id="home_hl_logo">
                        {/* TODO add user authentication back */}
                        <img
                            src={`${getBaseUrl()}/images/healthlevel-logo.svg`}
                            id="ctl00_img_home_logo"
                            alt="Foundations"
                            title="Foundations - Home"
                            className="header-logo-img"
                        />
                    </a>
                </div>
                {/* TODO -> saveAsPDF conditional */}
                {/* TODO -> handle system banner */}
                <div
                    id="header_menu_nav"
                    className="header-menu-app col-md-12 col-lg-6 d-flex flex-column align-items-end justify-content-center"
                >
                    <Navigation />
                    {currentUserData === undefined && (   // FP-11303 Checking for currentUserData to show/hide the Register and Sign In links
                    // FP-12086 Handling condition of currentUserData being null on first render. 
                        <div className="header-menu">
                            <ul>
                                <li>
                                    <div
                                        data-location="register"
                                        onClick={() => {
                                            if (location.hash === '#register') {
                                                // If already on register page, just reset form
                                                const event = new CustomEvent('resetRegistrationForm');
                                                window.dispatchEvent(event);
                                            }
                                            navigate('#register');
                                        }}
                                        id="ctl00_site_master_header_menu_container_link_register"
                                        className="redirect strong"
                                    >
                                        Register
                                    </div>
                                </li>
                                <li>
                                    <span className="menu-divider">&bull;</span>
                                </li>
                                <li>
                                    <div
                                        data-location="signin"
                                        onClick={() => navigate('#signin')}
                                        id="ctl00_site_master_header_menu_container_link_signin"
                                        className="redirect strong"
                                    >
                                        Sign In
                                    </div>
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
                {currentUserData && (
                    <div className="col-md-12">
                        <div ref={notificationContainerRef} id="notification_list_container_react" className="notification-container" style={{ display: "none" }}>
                            <input
                                name="ctl00$hidden_inbox_count"
                                type="hidden"
                                id="ctl00_hidden_inbox_count"
                                defaultValue={0}
                            />
                            <div className="header">
                                <div className="float-left">Inbox</div>
                                <div className="float-right header-close">
                                    <a
                                        href="javascript:void(0);"
                                        title="Close Inbox"
                                        onClick={closeNotifications}
                                    >
                                        close
                                    </a>
                                </div>
                                <div className="clear-both" />
                            </div>
                            <div id="notification_list" className={`content ${notifications.length === 0 ? "no-msg" : ""}`}>
                                {notifications.length === 0 ? (
                                    // Step 5: Show message when there are no notifications
                                    <div>No notifications found</div>
                                ) : (
                                    // Step 6: Display notifications when they are available
                                    <ul>
                                        {notifications.map((notification: any, index: any) => (
                                            <li key={index}>
                                                <div className="time" title={notification.timestamp}>
                                                    {timeago.format(notification.CreatedOn)}
                                                </div>
                                                <div className="message">
                                                    <div dangerouslySetInnerHTML={{ __html: notification.TargetText }} /> {/* need to find a better way to handle HTML inputs*/}
                                                </div>
                                                <div className="clear-both" />
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                
                {currentUserData && (
                <div className="col-md-12">
                <div ref={helpContainerRef} id="helpbox_dashboard" className="helpbox-wrapper" style={{ margin: '0 0 8px 0' }}>
                            <div ref={helpContainerRef} id="helpbox_dashboard" className="helpbox-wrapper" style={{
                                margin: '0 0 8px 0',
                                overflow: 'hidden',
                                transition: 'opacity 0.5s ease, max-height 0.5s ease',
                                opacity: showHelp ? 1 : 0,
                                maxHeight: showHelp ? '500px' : '0px',
                            }}>
                                <div className="helpbox-content-wrapper">
                                    <table className="helpbox-table-content">
                                        <tbody>
                                            <tr>
                                                <td className="helpbox-td-data">
                                                    <div id="ctl00_app_master_main_container_label_tutorial_workspace">
                                                    <div dangerouslySetInnerHTML={{ __html: message }} />
                                                    </div>
                                                </td>
                                                <td className="helpbox-td-tutorial">
                                                    <a
                                                        id="link_show_tutorial"
                                                        href={`${getBaseUrl()}/ux/index.html#home`}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleShowTutorialClick();
                                                        }}
                                                        title="Learn more about Foundations"
                                                    >
                                                        Show Tutorial
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="helpbox-tip-bottom">
                                    <img src="../images/help-tip-bottom.png?v=2014-1" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {currentUserData && (
                <div className="col-md-12">
                    <div
                        id="helpbox_dashboard"
                        className="helpbox-wrapper"
                        style={{ margin: '0 0 8px 0' }}
                    ></div>
                </div>
                )}
                {currentUserData && (
                <FoundationsGuide isOpen={showTutorial} onClose={handleTutorialClose} />
                )}
            </span>
        </NotificationContext.Provider>
        // <>HY</>
    )
}
function Navigation() {
    const { notifications, setNotifications, currentUserData, FindeMenuItems, setFindMenuItems, WorkspaceMenuState, SetWorkspaceMenuState, notificationContainerRef, setShowLoading, helpContainerRef,showHelp, setShowHelp,showTutorial,setShowTutorial } = useContext(NotificationContext);
    const [loading, setLoading] = useState(false);
    const [menuItems, setMenuItems] = useState([]);
    const [GetSearchables, { data: SearchablesData, error: SearchablesError, isLoading: SearchablesLoading }] = useSearchablesMutation();
    const [PerformSignOut, { data: SignOutData, error: SignOutError, isLoading: SignOutLoading }] = usePerformSignOutMutation()
    const [updateUserData] = useUpdateUserDataMutation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isHelpVisible, setIsHelpVisible] = useState(false); 
    // Notifications
    const [MyNotificationCount, setMyNotificationCount] = useState<number>(0);
    const showNotifications = async () => {
        const notificationContainer = notificationContainerRef.current;

        if (notificationContainer && notificationContainer.style.display === "block") {
            closeNotifications();
            return;
        }
        if (notificationContainer && notificationContainer.style.display === "none") {
            notificationContainer.style.display = "block";
        }

        // seting notification count to 0 to mark all notifications as read, but notification still do exist in the list.
        setMyNotificationCount(0);
        setLoading(true);
    };

    const closeNotifications = () => {
        const notificationContainer = notificationContainerRef.current;
        if (notificationContainer) {
            notificationContainer.style.display = "none";
        }
    };
    // set notification only on change of notifications.
    useEffect(() => {
        const count = notifications.filter((n: { DeliveredToUser: any; }) => !n.DeliveredToUser).length;
        setMyNotificationCount(count); // Update only with undelivered notifications
    }, [notifications]);

    const userPrivileges = currentUserData?.privileges || [];

    // Function to filter menu options based on user privileges
    const getFilteredMenuItems = (type: MenuType) => {
        const menu = menuOptions[type] || [];
        return menu.filter(
            (item) => !item.requiredPrivilege || userPrivileges?.includes(item.requiredPrivilege)
        );
    };

    useEffect(() => {
        if (currentUserData) {
            const fetchMenuData = async () => {

                try {
                    const response = await GetSearchables().unwrap();
                    setFindMenuItems(response);
                } catch (err) {
                    console.error('Failed to fetch workspaces: Header.tsx', err);
                }

            };
            fetchMenuData();
        }
    }, []);


    // useEffect(() => {
    //     const fetchMenuData = async () => {
    //         try {
    //             const response = await GetSearchables().unwrap();
    //             setFindMenuItems(response);
    //         } catch (err) {
    //             console.error('Failed to fetch workspaces: Header.tsx', err);
    //         }
    //     };

    //     fetchMenuData();
    // }, []);

    const AddWorkSpaceCallBack = (value: any) => {
        // DO NOTHING HERE :D
    }

    // const unicornScope = document.querySelector(".unicorn-scope");
    const handleSignOut = async () => {
        try {
            const response = await PerformSignOut().unwrap();


            if (response.Value) {
                cleanHLUserCookies()
                // Set the application workflow state to UNAUTHENTICATED
                dispatch(setAppWorkflowState(appWorkflowStates.UNAUTHENTICATED));
            }
            // $('body').removeClass('night-mode');

        } catch (error) {
            console.error("Sign out failed", error);
        }

    };
    const [Error, setError] = useState('')
    const [
        ExitProxy,
            { isLoading: proxyingUserLoading },
        ] = useExitProxyMutation()
    const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

    const handleExitProxyClick = () => {
        const currentUserId = Number(currentUserData.id);
        if (currentUserId === 0) {
            setError('No proxy user selected to exit. Please try again.');
        } else {
            const exitProxyUser = {
                userId: currentUserId
            };
            ExitProxy(exitProxyUser).unwrap().then(res => {
                if (res.data !== null) {
                    dispatch(setAppRedirectURL(redirectHome(currentUserData)));
                    dispatch(setAppWorkflowState(appWorkflowStates.FORCE_REDIRECT));
                } else {
                    setError("Unable to exit proxy for this user. Please try again later.");
                }
            }).catch(() => {
                setError("An error occurred while exiting proxy user. Please try again.");
            });
        }
    };

    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        setIsChecked(currentUserData?.DisplayMode === FoundationsConstants.DisplayMode.Night);
    }, [currentUserData]);

    const handleChange = async (event: any) => {

        setIsChecked(event.target.checked);

        // API CALL

        SetWorkspaceMenuState({ ...WorkspaceMenuState, isUserDropDownOpen: false })
        if (currentUserData) {
            try {
                const updatedUser = await updateUserData({
                    ...currentUserData,
                    DisplayMode: event.target.checked
                        ? FoundationsConstants.DisplayMode.Night
                        : FoundationsConstants.DisplayMode.Classic
                }).unwrap();

                // Redux state updates automatically with the response
                dispatch(setCurrentUserData(updatedUser)); // Update Redux store
            } catch (error) {
                console.error("Failed to update display mode", error);
            }
        }

        // Below is the working backbone.js code for theme switching.
        // TODO remove this code once react mirgration is on production.
        // if (event.target.checked) {
        //     // unicornScope && unicornScope.classList.add("night-mode")
        //     $(".vu-drill-wrapper .vu-table-drill-row .customer-color").css("background-color", function () {
        //         return adjustColor($(this).css("background-color"), 0.5);
        //     });
        //     $(".ocv-table-row>td>span").not(".darkened").css("background-color", function () {
        //         return adjustColor($(this).css("background-color"), 0.5);
        //     }).addClass("darkened");
        //     $(".card.currentstatus, .svg_barcode>div, #bannerText>span").css("background-color", function () {
        //         return adjustColor($(this).css("background-color"), 0.7);
        //     });
        // } else {
        //     // unicornScope && unicornScope.classList.remove("night-mode")
        //     $(".vu-drill-wrapper .vu-table-drill-row .customer-color").css("background-color", function () {
        //         return adjustColor($(this).css("background-color"), 2);
        //     });
        //     $(".ocv-table-row>td>span.darkened").css("background-color", function () {
        //         return adjustColor($(this).css("background-color"), 2);
        //     }).removeClass("darkened");
        //     $(".card.currentstatus, .svg_barcode>div, #bannerText>span").css("background-color", function () {
        //         return adjustColor($(this).css("background-color"), 10 / 7);
        //     });
        // }
    };

    const menuOptions = {
        [MenuType.USER]: [
            {
                content: (
                    <div
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => handleChange({ target: { checked: !isChecked } })}
                    >
                        Night Mode
                        <span style={{ float: "right" }}>
                            <input
                                type="checkbox"
                                className="generic-switch"
                                checked={isChecked}
                                readOnly // Prevent direct toggling, we handle it via parent click
                                style={{ pointerEvents: "none" }} // Prevent direct interaction
                            />
                        </span>
                    </div>
                ),
            },
            { content: "Invite", onClick: () => {navigate("#Invite")
                SetWorkspaceMenuState({
                    ...WorkspaceMenuState,
                    isUserDropDownOpen: false
                });
            } },
            { content: "Settings", onClick: () => {navigate("#UserSettings")
                SetWorkspaceMenuState({
                    ...WorkspaceMenuState,
                    isUserDropDownOpen: false
                });
            } },
            // { content: "Ask For Help", className: "afhVU_div", href: "javascript:void(0);", requiredPrivilege: "AllowHelpRequest" }, commenting this because of FP-11266
            { content: "Admin Tasks", onClick: () => {navigate("#AdminTasks")
                SetWorkspaceMenuState({
                    ...WorkspaceMenuState,
                    isUserDropDownOpen: false
                });
            }, requiredPrivilege: "AdminTasks" },
             ...(currentUserData?.proxyInfo?.proxyRole===1 ? [{ content: "Exit Proxy",  onClick: handleExitProxyClick  }] : []),
            { content: "Sign Out", className: "divider", onClick: handleSignOut, href: "javascript:void(0);" },
        ],
        [MenuType.WORKSPACE]: [
            {
                content: "Show workspaces", onClick: () => {
                    navigate("#home")
                    SetWorkspaceMenuState({
                        ...WorkspaceMenuState,
                        isWorkspaceDropDownOpen: false
                    });
                }
            }, // Need yo update once we have routing in place.
            {
                content: "Find workspaces", onClick: () => SetWorkspaceMenuState({
                    ...WorkspaceMenuState,
                    findWorkspaces: !WorkspaceMenuState.findWorkspaces,
                    isWorkspaceDropDownOpen:false
                }), requiredPrivilege: "Workspace_Add"
            },
            {
                content: "Find a Case", onClick: () => SetWorkspaceMenuState({ // need to look at this -- Check how the call is done and also check if HTML is coming from js, backend or uniorn
                    ...WorkspaceMenuState,
                    findCase: !WorkspaceMenuState.findCase,
                    isWorkspaceDropDownOpen:false
                }), requiredPrivilege: "AllowPatientLookup"
            },
            {
                content: "Add workspaces", onClick: () => SetWorkspaceMenuState({
                    ...WorkspaceMenuState,
                    addWorkspace: !WorkspaceMenuState.addWorkspace,
                    isWorkspaceDropDownOpen:false
                }), requiredPrivilege: "Workspace_Add"
            },
            // { content: "Snapshot feed", className: "divider", href: "javascript:void(0);" }
        ],
        [MenuType.FIND]: [],
    };
    useEffect(() => {
        if (FindeMenuItems) {
            setMenuItems(
                FindeMenuItems.map((item: any) => ({
                    content: item.Name,
                    href: `/${item.Links.GET[0]?.Url || ""}`,
                }))
            );
        }
    }, [FindeMenuItems]);

    const MyNotification = notifications.length; 

    // const showHelpContent = () => {
    //     setShowHelp(true);
    // };

    const showHelpContent = () => {
        setShowHelp(true); // This correctly sets the state to true
    };

    const hideHelpContent = () => {
        setShowHelp(false); // This correctly sets the state to true
    };
    const [hasItems, setHasItems] = useState(false);
    const handleHasItemsChange = (status: boolean) => {
        setHasItems(status);
    };

    return (
        <>
            {/* TODO -> handle logged in/not logged in */}
            <div className="header-menu-list user-header d-flex flex-row">
                {/* TODO add find menu (or alternative) here */}
                {/* Find DropDown  */}
                {currentUserData?.privileges?.includes("AllowPatientLookup") && (
                    <div className="item">
                        {currentUserData && (
                            <FindDropdown onHasItemsChange={handleHasItemsChange} />
                        )}
                    </div>
                )
                }
                {currentUserData?.privileges?.includes("AllowPatientLookup") && hasItems ? (
                    <div className="item">
                        <span className="menu-divider">&bull;</span>
                    </div>
                ) : null}
                {/* WorkSpace Drop Down */}
                <div className="item">
                    {/* TODO replace this link with a dropdown menu*/}
                    <div className="dropdown dropdown-pull-right" id="user_header_dropdown">
                        {currentUserData && (
                            <GenericDropdown
                                id="workspace_header_dropdown"
                                toggleClass="noclick"
                                toggleText="Workspaces "
                                isOpen={WorkspaceMenuState.isWorkspaceDropDownOpen}
                                onMouseEnter={() => SetWorkspaceMenuState({ ...WorkspaceMenuState, isWorkspaceDropDownOpen: true, isFindDropDownOpen: false, isUserDropDownOpen: false })}
                                onMouseLeave={() => SetWorkspaceMenuState({ ...WorkspaceMenuState, isWorkspaceDropDownOpen: false })}
                                menuItems={getFilteredMenuItems(MenuType.WORKSPACE)}
                            />
                        )}
                        <AddWorkspaceDialog
                            isOpen={WorkspaceMenuState.addWorkspace}
                            onClose={() => SetWorkspaceMenuState({
                                ...WorkspaceMenuState,
                                addWorkspace: !WorkspaceMenuState.addWorkspace,
                            })} // Close the dialog
                            AddWorkSpaceCallBack={AddWorkSpaceCallBack}
                        />
                        <FindWorkspaceDialog
                            isOpen={WorkspaceMenuState.findWorkspaces}
                            onClose={() => SetWorkspaceMenuState({
                                ...WorkspaceMenuState,
                                findWorkspaces: !WorkspaceMenuState.findWorkspaces,
                            })} // Close the dialog
                            setShowLoading={setShowLoading}
                        />
                        <PatientCaseLookupDialog
                            isOpen={WorkspaceMenuState.findCase}
                            onClose={() => SetWorkspaceMenuState({
                                ...WorkspaceMenuState,
                                findCase: !WorkspaceMenuState.findCase,
                            })} // Close the dialog
                        />
                    </div>
                </div>
                {currentUserData && (
                    <div className="item">
                        <span className="menu-divider">&bull;</span>
                    </div>
                )}
                {/* User Profile DropDown  */}
                <div className="item">
                    {/* TODO replace this link with a dropdown menu*/}
                    {currentUserData && (
                        <GenericDropdown
                            id="user_header_dropdown"
                            containerClass="dropdown-pull-right"
                            toggleClass="noclick"
                            toggleText={currentUserData?.AccountInfo?.name + ' '} 
                            isOpen={WorkspaceMenuState.isUserDropDownOpen}
                            onMouseEnter={() => SetWorkspaceMenuState({ ...WorkspaceMenuState, isUserDropDownOpen: true, isWorkspaceDropDownOpen: false, isFindDropDownOpen: false })}
                            onMouseLeave={() => SetWorkspaceMenuState({ ...WorkspaceMenuState, isUserDropDownOpen: false })}
                            menuItems={getFilteredMenuItems(MenuType.USER)}
                        />
                    )}
                </div>
            </div>

            <div className="header-info header-menu-list d-flex flex-row">
                {/* TODO add role title from props */}
                <div id="user_role_name" className="item">
                    {currentUserData?.roles?.map((role: string, index: number) => (
                        <span key={index} className="user-role">
                            {role}
                            {index < currentUserData?.roles?.length - 1 && ", "}
                        </span>
                    ))}
                </div>
                {/* TODO add groups names */}
                {/* TODO add  personalizationInfoDisplay */}
                {currentUserData?.personalizationInfo?.Value?.["Procedure Location"] && (
                  <>
                    <div className="item">
                      <span className="menu-divider">&bull;</span>
                    </div>
                    <div
                      id="user_procedure_location" className="item">
                      {currentUserData?.personalizationInfo?.Value?.["Procedure Location"]
                        ?.slice(0, 2)
                        .map((location: string, index: number) => (
                          <span key={index} className="user-location">
                            {location}
                            {index < Math.min(1, currentUserData?.personalizationInfo?.Value?.["Procedure Location"].length - 1) && ", "}
                          </span>
                      ))}
                
                      {currentUserData?.personalizationInfo?.Value?.["Procedure Location"]?.length > 2 && (
                        <span className="ellipsis">...</span>
                      )}
                    </div>
                  </>
                )}
                {currentUserData && (
                    <div className="item">
                        <span className="menu-divider">&bull;</span>
                    </div>
                )}
                {/* TODO add inbox events and hide/show styling*/}
                {currentUserData && (
                    <div
                        id="home_notifications"
                        className="item hide"
                        style={{ display: "block" }}
                    >
                        <div id="link_notif_container" className="float-left inbox-label">
                            <a id="link_notifications" className="inbox" onClick={showNotifications} style={{ cursor: "pointer" }} >
                                Inbox
                            </a>
                            <span
                                id="link_notifications_count_react"
                                className={`notification-count ml-1 ${MyNotificationCount !== 0 ? 'unread' : 'read'}`}
                            >
                                {MyNotificationCount}
                            </span>

                        </div>
                        {/* <div id="notification_list_react"></div> */}
                    </div>
                )}
                {currentUserData && (
                    <div id="home_help_divider" className="item">
                        <span className="menu-divider">&bull;</span>
                    </div>
                )}
                {/* TODO add events back to show/hide help links  */}
                {currentUserData && (
                    <div id="home_help" className="item help">
                        <a
                             id={showHelp ? "link_hide_help" : "link_show_help"}
                            title={showHelp ? "Hide all help messages in this page" : "Show all help messages in this page"}
                            onClick={showHelp ? hideHelpContent : showHelpContent}
                            style={{ cursor: "pointer" }}
                        >
                            {showHelp ? "Hide Help" : "Show Help"}
                        </a>
                   </div>
                )}
            </div>
            {/* TODO add pre-sign in navigation bar here */}
        </>
        // <>HY</>
    )
}